/* ErrorCard.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ErrorCard.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import { cx } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { messages } from './messages';
var styles = {
  container: "_2rko12b0 _19itia51 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
export var ErrorCard = function ErrorCard(_ref) {
  var query = _ref.query;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(Fragment, null, isOpen ? /*#__PURE__*/React.createElement(Inline, {
    xcss: cx(styles.container),
    spread: "space-between",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, formatMessage(messages.errorMessage, {
    title: query
  })), /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: CrossIcon,
    label: formatMessage(messages.close),
    onClick: function onClick() {
      return setIsOpen(false);
    }
  })) : null);
};